export const heroData = {
  title: '南宫集团',
  subtitle: '创新驱动发展 · 品质铸就未来',
  description: '南宫集团是一家多元化发展的综合性企业集团，业务涵盖科技研发、产业投资、国际贸易等多个领域。我们始终坚持"诚信为本、创新为魂"的经营理念，致力于为客户提供卓越的产品与服务。',
  ctaPrimary: '立即下载APP',
  ctaSecondary: '了解更多',
};

export const featuresData = [
  {
    icon: 'ri-smartphone-line',
    title: '官方正版APP',
    description: '南宫集团官方正版客户端，安全可靠，无病毒无插件，保障您的信息安全与使用体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全下载通道',
    description: '采用SSL加密传输技术，提供iOS与Android双平台官方下载，杜绝第三方不明来源。',
  },
  {
    icon: 'ri-rocket-line',
    title: '极速流畅体验',
    description: '最新版本客户端经深度优化，启动速度快、运行流畅稳定，给您丝滑般的使用感受。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，随时为您解答疑问、处理问题，让您使用无忧。',
  },
];

export const downloadData = {
  title: '南宫集团官方APP下载',
  subtitle: '支持 iOS / Android 双端下载，安全可靠',
  iosVersion: 'v3.6.2',
  iosSize: '128MB',
  androidVersion: 'v3.6.2',
  androidSize: '96MB',
  qrTitle: '扫码下载',
  securityNote: '请认准南宫集团官方网站，谨防假冒应用。下载即表示您同意《用户服务协议》与《隐私政策》。',
};

export const statsData = [
  { value: '5000万+', label: '累计用户' },
  { value: '200+', label: '覆盖国家与地区' },
  { value: '15年', label: '行业深耕' },
  { value: '99.9%', label: '服务满意度' },
];

export const partnersData = [
  { name: '华为技术', icon: 'ri-smartphone-line' },
  { name: '阿里巴巴', icon: 'ri-shopping-bag-3-line' },
  { name: '腾讯科技', icon: 'ri-wechat-line' },
  { name: '百度智能', icon: 'ri-brain-line' },
  { name: '京东集团', icon: 'ri-store-3-line' },
  { name: '字节跳动', icon: 'ri-tiktok-line' },
  { name: '网易集团', icon: 'ri-mail-line' },
  { name: '小米科技', icon: 'ri-android-line' },
];